import { createBrowserRouter } from "react-router";
import type { RouteObject } from "react-router";
import { LazyWrapper } from "pixelize-design-library";
import { RequireAuth } from "@core/auth";
import { NotFoundPage, RouteErrorPage } from "@core/components";
import { AppShell } from "@core/layout";
import { protectedRoutes, publicRoutes } from "@modules/registry";

const LOGIN_PATH = "/login";
const standaloneRoutes = publicRoutes
  .filter((route) => route.path === LOGIN_PATH)
  .map((route) => ({ ...route, element: <LazyWrapper>{route.element}</LazyWrapper> }));
const shellPublicRoutes = publicRoutes.filter((route) => route.path !== LOGIN_PATH);

export const routes: RouteObject[] = [
  ...standaloneRoutes,
  {
    element: <AppShell />,
    errorElement: <RouteErrorPage />,
    children: [
      ...shellPublicRoutes,
      { element: <RequireAuth />, children: [...protectedRoutes] },
      { path: "*", element: <NotFoundPage /> },
    ],
  },
  { path: "*", element: <NotFoundPage /> },
];

export const createRouter = () => createBrowserRouter(routes);
